import script from "./Course.vue?vue&type=script&setup=true&lang=js"
export * from "./Course.vue?vue&type=script&setup=true&lang=js"

import "./Course.vue?vue&type=style&index=0&id=8247d286&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8247d286"]])

export default __exports__